export default __webpack_public_path__ + "static/media/invoke-logo.efcde793.svg";